<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '新增字典项' : '编辑字典项'"
    :enableDrag="true"
    width="500px"
    @close="cancel">
    <dynamic-form :formConfig="formConfig" v-model="form" @submit="doSubmit" @cancelForm="cancel" ref="pageForm"></dynamic-form>
  </drag-dialog>
</template>

<script>
import { add, edit } from '@/api/dictDetail'
import DragDialog from '@/components/DragDialog'
import '@/components/dynamic-form';
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    dictId: {
      type: String,
      required: true,
      default: ''
    }
  },
  components: {
    DragDialog
  },
  data() {
    return {
      loading: false, dialog: false,
      form: {},
      formConfig: {
        formItemList: [
            {
              type: "text",
              key: "label",
              label: "字典标签",
              placeholder: "请输入标签名称",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "text",
              key: "value",
              label: "字典值",
              placeholder: "请输入字典值",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "number",
              key: "sorting",
              label: "排序",
              value: 0,
              placeholder: "请输入排序",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "textarea",
              key: "remark",
              label: "描述",
              placeholder: "请输入描述"
            }
        ]
      }
    }
  },
  methods: {
    cancel() {
      this.resetForm()
    },
    doSubmit(val) {
      this.form = val
      this.form.parentId = this.dictId
      if (this.isAdd) {
          this.doAdd()
      } else this.doEdit()
    },
    doAdd() {
      add(this.form).then(res => {
        this.resetForm()
        this.$notify({
          title: '添加成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.$parent.dataTableInit()
      }).catch(err => {
        this.loading = false
        console.log(err.response)
      })
    },
    doEdit() {
      edit(this.form).then(res => {
        this.resetForm()
        this.$notify({
          title: '修改成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.$parent.dataTableInit()
      }).catch(err => {
        this.loading = false
        console.log(err.response)
      })
    },
    resetForm() {
      this.dialog = false
      this.$refs.pageForm.resetForm()
    }
  }
}
</script>

<style scoped>

</style>
